export enum FieldType {
    HeaderField = "HeaderField",
    MultilineTextField = "MultilineTextField",
    MultiSelectField = "MultiSelectField",
    SelectField = "SelectField",
    SingleLineTextField = "SingleLineTextField",
    StaticField = "StaticField",
    DateField = "DateField",
}
export type FormFieldConfigs = FormFieldConfig | FormFieldConfig[];

export interface SubmitDisplayPair {
    submit: string;
    display: string;
}

export interface DependencyControlStatic extends Record<string, string | SubmitDisplayPair | DependencyControlStatic> {
    id: string;
}

export interface DependencyControlSelect extends Record<string, string | SubmitDisplayPair[]> {
    id: string;
}

export interface ToggleDisplayControl {
    display: string;
}

export interface ToggleDisplayControlText extends Record<string, string | ToggleDisplayControl | ToggleDisplayControlText> {
    id: string;
}

export interface Clearer {
    fieldsToClear?: string[];
}

export interface Validatable {
    required?: boolean;
    validationRegex?: RegExp;
}

export interface FormConfig {
    formBody: FormBody;
    formFooter: FormFooter;
}

export interface FormBody {
    formFields: FormFieldConfigs[];
}

export interface FormFooter {
    clearButton?: FooterControl;
    appEventButton?: FooterControl;
    requiredField?: FooterControl;
    counterLabel?: FooterControl;
}

export interface FooterControl extends Clearer {
    displayText: string;
    type: string;
    appEventName?: string;
    visible?: boolean;
    warningOverlay?: {
        bodyText: string;
        cancelButtonText: string;
        continueButtonText: string;
        headerText: string;
    };
}

export interface FormFieldConfig extends Validatable {
    fieldType: FieldType;
    fieldId: string;
}

export interface SingleLineTextFieldConfig extends FormFieldConfig {
    fieldType: FieldType.SingleLineTextField;
    placeholder?: string;
    characterLimit?: string;
    copyToClipboard?: boolean;
    labelText: string;
    ToggleDisplayControl?: ToggleDisplayControlText;
    warningOverlay?: {
        bodyText: string;
        cancelButtonText: string;
        continueButtonText: string;
        headerText: string;
    };
}

export interface DateFieldConfig extends FormFieldConfig {
    fieldType: FieldType.DateField;
    placeholder?: string;
    copyToClipboard?: boolean;
    labelText: string;
    ToggleDisplayControl?: ToggleDisplayControlText;
}

export interface MultilineTextFieldConfig extends FormFieldConfig {
    fieldType: FieldType.MultilineTextField;
    placeholder?: string;
    characterLimit?: string;
    hasCopyButton?: boolean;
    copyToClipboard?: boolean;
    labelText: string;
    ToggleDisplayControl?: ToggleDisplayControlText;
    warningOverlay?: {
        bodyText: string;
        cancelButtonText: string;
        continueButtonText: string;
        headerText: string;
    };
}

export interface SelectFieldConfig extends FormFieldConfig, Clearer {
    fieldType: FieldType.SelectField;
    placeholder?: string;
    copyToClipboard?: boolean;
    labelText: string;
    width?: number;
    keyValues?: Record<string, string>;
    dependencyControl?: DependencyControlSelect;
}

export interface MultiSelectFieldConfig extends FormFieldConfig {
    fieldType: FieldType.MultiSelectField;
    copyToClipboard?: boolean;
    labelText: string;
    width?: number;
    keyValues?: Record<string, string>;
    dependencyControl?: DependencyControlSelect;
}

export interface StaticFieldConfig extends FormFieldConfig {
    fieldType: FieldType.StaticField;
    copyToClipboard?: boolean;
    labelText: string;
    dependencyControl?: DependencyControlStatic;
    stateControl?: string;
}


export interface HeaderFieldConfig extends FormFieldConfig {
    fieldType: FieldType.HeaderField;
    labelText: string;
}

export interface WindowFormSettings {
    windowForm: {
        cookieKeyName: string;
        formConfiguration: FormConfig;
        inParamName: string;
    };
}

export default {
    windowForm: {
        cookieKeyName: "NITWindowForm",
        formConfiguration: {},
        inParamName: "WindowForm",
    },
} as WindowFormSettings;



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/window-form.ts